import axios from "axios";
import { useAxiosHook } from "./useAxiosHook";
import { useDispatch } from "react-redux";
import { cachedDataItemSet } from "../redux/actions/cachedDataActions";
import { CACHED_DATA_REDUCER_TYPES } from "../redux/reducers/cachedDataReducer";
import { validateRequiredFields } from "../_src_shared/utils/functions/validateRequiredFields";

const ROUTE_PREFIX = "notifications";

export const useNotificationFlowsHook = () => {
  const {
    axiosPostIsLoading,
    isLoading,
    axiosGetIsLoading,
    axiosError,
    axiosGetRequest,
    axiosPostRequest,
  } = useAxiosHook();

  const loading = isLoading || axiosGetIsLoading || axiosPostIsLoading;
  const error = axiosError;
  const dispatch = useDispatch();

  const getEmailTemplates = async ({ onSuccessFn, onCompleteFn, onFailFn }) => {
    const endpoint = `${ROUTE_PREFIX}/get_email_templates`;
    const source = axios.CancelToken.source();
    const CACHED_DATA_KEY = CACHED_DATA_REDUCER_TYPES.EMAIL_TEMPLATES;

    await axiosGetRequest({
      name: "Get All Email Templates",
      path: endpoint,
      cancelSource: source,
      onSuccessFn: (d) => {
        dispatch(cachedDataItemSet(CACHED_DATA_KEY, d));
      },
      onCompleteFn,
      onFailFn,
    });
  };

  const createEmailTemplate = async ({ template, onCompleteFn, onFailFn }) => {
    const endpoint = `${ROUTE_PREFIX}/create_email_template`;
    const source = axios.CancelToken.source();
    const CACHED_DATA_KEY = CACHED_DATA_REDUCER_TYPES.EMAIL_TEMPLATES;

    await axiosGetRequest({
      name: "Create Email Template",
      path: endpoint,
      payload: template,
      cancelSource: source,
      onSuccessFn: (d) => {
        dispatch(cachedDataItemSet(CACHED_DATA_KEY, d));
      },
      onCompleteFn,
      onFailFn,
    });
  };

  // const sendEmailTemplate = async ({
  //   dealId,
  //   templateName, // wireInstructions || otherFutureUpdateableObject
  //   data,
  //   onSuccessFn,
  //   onCompleteFn,
  //   onSuccessMsg = "Email Template Sent Successfully",
  //   onFailFn,
  // }) => {
  //   validateRequiredFields({ dealId, templateName, data });
  //   const endpoint = `${ROUTE_PREFIX}/send_email_template/${dealId}/${templateName}`; // example endpoint name
  //   const source = axios.CancelToken.source();

  //   await axiosPostRequest({
  //     name: "Send Email Template",
  //     path: endpoint,
  //     payload: data,
  //     cancelSource: source,
  //     onSuccessFn,
  //     onSuccessMsg,
  //     onCompleteFn,
  //     onFailFn,
  //   });
  // };

  return {
    loading,
    error,
    createEmailTemplate,
    getEmailTemplates,
  };
};
